// Event Listener for document ready
document.addEventListener("DOMContentLoaded", function () {
  // Variables
  const dogsDropdown = document.querySelector(".acq-flow__main-dog-dropdown")
  const formContainer = document.querySelector(".acq-flow__main-form");
  const mainContent = document.querySelector(".main-content");
  const addRowButton = document.querySelector(".acq-flow__add-dog-button");
  const cartOverlay = document.querySelector(".side-cart");
  const acquisitionForm = document.querySelector(".acq-flow__main-form");
  //   Get translations from DOM
  const selectText = document.querySelector(".acq-flow__select")?.value;
  const genderText = document.querySelector(".acq-flow__gender")?.value;
  const maleText = document.querySelector(".acq-flow__male")?.value;
  const femaleText = document.querySelector(".acq-flow__female")?.value;
  const requiredFieldText = document.querySelector(
    ".acq-flow__required-field"
  )?.value;
  const dogsNameLable = document.querySelector(".acq-flow__dogs_name")?.value;
  const dogsNamePlaceholder = document.querySelector(
    ".acq-flow__dogs_name_placeholder"
  )?.value;
  const cartCloseButton = document.querySelector(".side-cart__close-button");
  const customerEmail = document.querySelector('.barkyn-customer')

  if (customerEmail) {
    localStorage.setItem('klaviyoEmail', customerEmail.value)
  }

  if (cartCloseButton) {
    cartCloseButton.addEventListener("click", function (e) {
      if (window.location.href.includes("o-plano-alimentar-do-seu-cao")) {
        localStorage.removeItem("petDataForm");
        window.location.href =
          "/products/o-plano-alimentar-do-seu-cao?variant=48687640084804";
      }
    });
  }

  //   Reset ritual flow
  if (cartOverlay) {
    cartOverlay.addEventListener("click", function (e) {
      if (e.target.classList.contains("cart-ritual-product-button")) {
        localStorage.removeItem("petDataForm");
        window.location.href =
          "/products/o-plano-alimentar-do-seu-cao?variant=48687640084804";
      } else if (
        window.location.href.includes("o-plano-alimentar-do-seu-cao")
      ) {
        console.log("oi");
        localStorage.removeItem("petDataForm");
        window.location.href =
          "/products/o-plano-alimentar-do-seu-cao?variant=48687640084804";
      }
    });
  }

  if (acquisitionForm) {
    acquisitionForm.addEventListener("click", function (e) {
      if (e.target.classList.contains("acq-fake-dropdown__container")) {
        // Open dropdown
        e.target
          .querySelector(".acq-fake-dropdown__options")
          .classList.toggle("active");

        // Rotate arrow
        e.target.querySelector("svg").classList.toggle("active");
      }

      if (e.target.classList.contains("acq-fake-dropdown__option")) {
        const parent = e.target.parentElement;

        const selectedArrow = document.querySelector(
          ".acq-fake-dropdown__container svg.active"
        );

        if (selectedArrow) selectedArrow.classList.remove("active");

        if (parent) parent.classList.remove("active");
      }
    });
  }

  // Close dropdown when click outside
  if (mainContent)
    mainContent.addEventListener("click", function (e) {
      if (
        !e.target.classList.contains("acq-fake-dropdown__option") &&
        !e.target.classList.contains("acq-fake-dropdown__container")
      ) {
        const dropdown = document.querySelector(
          ".acq-fake-dropdown__options.active"
        );

        const selectedArrow = document.querySelector(
          ".acq-fake-dropdown__container svg.active"
        );

        if (selectedArrow) selectedArrow.classList.remove("active");

        if (dropdown) dropdown.classList.remove("active");
      }
    });

  //   Remove form row
  const removeFormRow = (index) => {
    const formRow = document.querySelector(`#form-row-${index}`);

    const petData = localStorage.getItem("petDataForm");

    const petDataArray = JSON.parse(petData);

    if (petDataArray.length > 1 || dogsDropdown) {
      const newPetDataArray = petDataArray.filter(
        (item) => +item.index !== +index
      );

      if (formRow) {
        formRow.remove();

        if (newPetDataArray.length === 1 && !dogsDropdown) {
          document
            .querySelector(".acq-flow__delete-button")
            .classList.add("hidden");
        }
        if (newPetDataArray.length) {
          localStorage.setItem("petDataForm", JSON.stringify(newPetDataArray));
        } else {
          localStorage.removeItem("petDataForm");
        }
      }
    }
  };

  //  Bind all avents on dynamic elements
  if (formContainer)
    formContainer.addEventListener("click", function (event) {
      const element = event.target;

      if (element.classList.contains("acq-flow__delete-icon")) {
        const index = element.dataset.delete;
        removeFormRow(index);
      }
    });

  if (addRowButton) {
    addRowButton.addEventListener("click", function () {
      const hiddenRemoveButton = document.querySelector(
        ".acq-flow__delete-button.hidden"
      );

      if (hiddenRemoveButton) hiddenRemoveButton.classList.remove("hidden");

      const petData = localStorage.getItem("petDataForm");
      const petDataArray = JSON.parse(petData);

      const rows = document.querySelectorAll(".acq-flow__main-form-row");
      if (dogsDropdown && rows.length < 1) {
        if (!petData || !petDataArray || !petDataArray.length) {
          const petData = [{ index: 0 }];
          localStorage.setItem("petDataForm", JSON.stringify(petData));
        }
        renderPetForm();
        return
      }

      const index = petDataArray[petDataArray.length - 1].index + 1;

      petDataArray.push({ index });

      localStorage.setItem("petDataForm", JSON.stringify(petDataArray));

      setTimeout(() => {
        renderPetForm();
      }, 150);
    });
  }

  const renderFormRow = (index, dogsData = 0, name, gender) => {
    const formRow = `
    <div class="acq-flow__main-form-row" id="form-row-${index}" data-formrow="${index}">
            <div class="product-dropdown-options__option-container acq-flow__gender-dropdown">
            <fake-dropdown class="acq-fake-dropdown" id="product_options_1" label="idade do seu cão" selected-option-value="Puppy" data-ref="fakeDropdown">
                <div class="acq-fake-dropdown__container">
                <button type="button" class="fake-dropdown__target" data-ref="target">
                    <div class="acq-fake-dropdown__label-and-selected-option">
                        <div class="acq-fake-dropdown__label" for="product_options_1">
                            ${genderText}
                        </div>
                    <div class="acq-fake-dropdown__selected-option" data-ref="selectedOptionElement">
                        ${gender ? gender : selectText}
                    </div>
                    </div>
                    <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6612 0.736593C12.8937 0.969123 12.8937 1.34674 12.6612 1.58026L7.8228 6.41768C7.44717 6.79331 6.94833 7 6.41768 7C5.88703 7 5.3872 6.79331 5.01256 6.41768L0.175143 1.58026C-0.058381 1.34674 -0.058381 0.969123 0.175143 0.736593L0.736594 0.175143C0.969124 -0.0583811 1.34674 -0.0583811 1.58026 0.175143L6.41768 5.01256L11.2561 0.175143C11.4886 -0.0583811 11.8662 -0.0583811 12.0998 0.175143L12.6612 0.736593Z" fill="#393427"></path>
                    </svg>
                </button>

                <div class="acq-fake-dropdown__options">
                    <button type="button" class="acq-fake-dropdown__option fake-dropdown__option--selected" data-ref="option" data-option-ref="option1" data-value="Puppy" data-text="Puppy">
                        ${maleText}
                    </button>
                    <button type="button" class="acq-fake-dropdown__option" data-ref="option" data-option-ref="option1" data-value="Adulto" data-text="Adulto" style="display: inline-flex;">
                        ${femaleText}
                    </button>
                </div>
                </div>
            <input class="fake-dropdown__input" type="hidden" value="Puppy" data-ref="input">
        </fake-dropdown>
        </div>

        <div class="dog-name-input-wrapper acq-flow__text-input">
        <label for="dog-name" class="dog-name-label">${dogsNameLable}</label>
        <input
          class="dog-name-input"
          id="dog-name"
          type="text"
          placeholder="${dogsNamePlaceholder}"
          value="${name ? name : ""}">

        <div class="acq-flow__delete-button acq-flow__delete-icon ${dogsData === 1 && !dogsDropdown ? "hidden" : ""
      }" data-delete="${index}">
           <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_766_782)"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.9998 10.6001V17.4001C14.9998 17.7311 14.7308 18.0001 14.3998 18.0001H13.5998C13.2688 18.0001 12.9998 17.7311 12.9998 17.4001V10.6001C12.9998 10.2681 13.2688 10.0001 13.5998 10.0001H14.3998C14.7308 10.0001 14.9998 10.2681 14.9998 10.6001ZM10.9998 10.6001V17.4001C10.9998 17.7311 10.7308 18.0001 10.3998 18.0001H9.59984C9.26884 18.0001 8.99984 17.7311 8.99984 17.4001V10.6001C8.99984 10.2681 9.26884 10.0001 9.59984 10.0001H10.3998C10.7308 10.0001 10.9998 10.2681 10.9998 10.6001ZM17.5998 10.0001C17.2688 10.0001 16.9998 10.2681 16.9998 10.6001V18.0001C16.9998 18.5531 16.9388 19.5211 16.5308 19.8021C16.2418 20.0001 15.6528 19.9961 14.9998 20.0001H8.92884C8.33484 19.9961 7.75684 20.0001 7.46884 19.8021C7.06084 19.5211 6.99984 18.5531 6.99984 18.0001V10.6001C6.99984 10.2681 6.73084 10.0001 6.39984 10.0001H5.99984C5.99984 9.44709 6.06084 8.47809 6.46884 8.19809C6.75784 7.99909 7.32784 8.00009 7.99984 8.00009H16.0708C16.6768 7.99109 17.2418 7.99909 17.5308 8.19809C17.9388 8.47809 17.9998 9.44709 17.9998 10.0001H17.5998ZM10.4688 4.19809C10.7568 3.99909 11.3308 3.98809 11.9288 4.00009H12.0708C12.6618 3.99009 13.2428 3.99909 13.5308 4.19809C13.9388 4.47809 13.9998 5.44709 13.9998 6.00009H9.99984C9.99984 5.44709 10.0608 4.47809 10.4688 4.19809ZM18.6648 6.55009C17.8638 5.99909 16.9048 6.00309 15.9998 6.00009C15.9998 4.29709 15.5628 3.16809 14.6648 2.55009C13.8638 1.99909 12.9248 2.00109 12.0698 2.00009H11.9298C11.0808 1.99809 10.1348 1.99909 9.33484 2.55009C8.43684 3.16809 7.99984 4.29709 7.99984 6.00009H7.92984C7.06784 5.99309 6.13484 5.99909 5.33484 6.55009C4.55984 7.08309 4.12884 7.99709 4.02384 9.33209C3.99684 9.68809 4.26584 10.0001 4.62284 10.0001H4.99984V18.0001C4.99984 19.7031 5.43684 20.8311 6.33484 21.4501C7.13584 22.0001 8.09084 22.0001 8.99984 22.0001H15.0698H15.1388C15.9628 22.0001 16.8858 21.9861 17.6648 21.4501C18.5628 20.8311 18.9998 19.7031 18.9998 18.0001V10.0001H19.3768C19.7338 10.0001 20.0028 9.68809 19.9758 9.33209C19.8708 7.99709 19.4398 7.08309 18.6648 6.55009Z" fill="#C6AFA1"/></g><defs><clipPath id="clip0_766_782"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
           </span>
        </div> 
    </div>
    </div>
  `;

    return formRow;
  };

  const setInitialPetData = () => {
    const petData = [{ index: 0 }];

    localStorage.setItem("petDataForm", JSON.stringify(petData));

    renderPetForm();
  };

  const generateHTMLForm = (petDataArray) => {
    const existedValues = [];
    for (const dog of petDataArray) {
      const existedRow = document.querySelector(`#form-row-${dog.index}`);
      const name = existedRow?.querySelector(".dog-name-input")?.value;
      const existedGender = existedRow?.querySelector(
        ".acq-fake-dropdown__selected-option"
      )?.innerText;
      const gender = existedGender ? existedGender.trim() : "";

      if (name || gender) {
        existedValues.push({ index: dog.index, name, gender });
      }
    }
    // Reset form
    if (formContainer) formContainer.innerHTML = "";

    for (const dog of petDataArray) {
      const existedRowInputs = existedValues.find(
        (item) => item.index === dog.index
      );

      const existedName = existedRowInputs?.name;
      const existedGender = existedRowInputs?.gender;

      if (formContainer) {
        const generatedRow = renderFormRow(
          dog.index,
          petDataArray.length,
          existedName,
          existedGender
        );

        formContainer.innerHTML += generatedRow;
      }
    }
  };

  const renderPetForm = () => {
    const petData = localStorage.getItem("petDataForm");
    const petDataArray = JSON.parse(petData);

    if (petData && petDataArray.length) {
      generateHTMLForm(petDataArray);
    } else {
      setInitialPetData();
    }
  };

  if (!dogsDropdown) {
    renderPetForm();
  } else {
    const petData = [{ index: 0 }];
    localStorage.setItem("petDataForm", JSON.stringify(petData));
  }
});
